import { render, staticRenderFns } from "./PlanningService.vue?vue&type=template&id=f2fc4dec"
import script from "./PlanningService.vue?vue&type=script&lang=js"
export * from "./PlanningService.vue?vue&type=script&lang=js"
import style0 from "./PlanningService.vue?vue&type=style&index=0&id=f2fc4dec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports